import { render, staticRenderFns } from "./wine-collections-investor.vue?vue&type=template&id=e4f89e6a&scoped=true"
import script from "./wine-collections-investor.vue?vue&type=script&lang=js"
export * from "./wine-collections-investor.vue?vue&type=script&lang=js"
import style0 from "./wine-collections-investor.vue?vue&type=style&index=0&id=e4f89e6a&prod&scoped=true&lang=css"
import style1 from "./wine-collections-investor.vue?vue&type=style&index=1&id=e4f89e6a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f89e6a",
  null
  
)

export default component.exports